// extracted by mini-css-extract-plugin
module.exports =  {"block":"block__v9AOy","inline":"inline__gALQw","withTitle":"withTitle__RKCqR","title":"title__FiJ3x","itemLabel":"itemLabel__vOigV","itemValue":"itemValue__YRlfN"};